<template>
  <div class="login-container">
    <h1>新增账号</h1>
    <form @submit.prevent="login">
      <div class="form-group">
        <label for="phone">手机号:</label>
        <input type="text" id="phone" v-model="phone" required />
      </div>
      <div class="form-group">
        <label for="password">密码:</label>
        <input type="password" id="password" v-model="password" required />
      </div>
      <button type="submit">提交</button>
    </form>
    <!-- <button @click="removeToken">
      清楚token
    </button> -->
  </div>
</template>

<script>
import { ref } from 'vue';
// import { useRouter  } from "vue-router";
import { getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';

export default {
  setup() {
    const phone = ref('');
    const password = ref('');
    // const router = useRouter(); 
    const { proxy } = getCurrentInstance();

    const login = async () => {
      const url = '/login/addUser';
      proxy.$tools.request(url, 
      {
        reqBody:{mobileNo:phone.value,password:password.value},
      })
        .then(response => {
          // 处理响应数据
          if('00000000' === response.data.rspHead.returnCode){
            // router.push('/');
             // 返回上级页面，可以使用router的go方法
            ElMessage.success('新增成功');
            location.reload();
          }else{
            ElMessage.error(response.data.rspHead.returnMsg); // 弹框提示错误信息
          }
        })
        .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };



    return {
      phone,
      password,
      login,
    };
  },
};
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.logo {
  display: block;
  margin: 0 auto 20px;
  max-width: 100%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
